(function () {
  function initProductTabs(root) {
    var tabsRoot=root.querySelector('[data-nt-product-tabs]');
    if(!tabsRoot||tabsRoot.dataset.ntTabsInitialized==='true')return;
    tabsRoot.dataset.ntTabsInitialized='true';tabsRoot.classList.add('nt-pdp-anchor-sections');
    var nav=tabsRoot.querySelector('.nt-pdp-tabs__list'),names=['description','shipping','reviews'];
    var tabs=names.map(function(name){return tabsRoot.querySelector('[data-nt-product-tab="'+name+'"]');});
    var panels=names.map(function(name){return tabsRoot.querySelector('[data-nt-product-panel="'+name+'"]');});
    nav.setAttribute('role','navigation');
    tabs.forEach(function(tab,i){nav.append(tab);tab.removeAttribute('role');tab.removeAttribute('aria-selected');tab.tabIndex=0;
      var panel=panels[i];panel.hidden=names[i]==='reviews' && tab.hidden;panel.classList.add('is-active');panel.setAttribute('role','region');tabsRoot.append(panel);
      var heading=document.createElement('h2');heading.className='nt-pdp-anchor-heading';heading.textContent=['DESCRIPTION','SHIPPING & REFUND','REVIEWS'][i];panel.prepend(heading);
    });
    function headerHeight(){
      var height=0;
      document.querySelectorAll('header,[data-sticky-header],.sticky-header').forEach(function(el){
        if(root.contains(el))return;var style=getComputedStyle(el),r=el.getBoundingClientRect();
        if((style.position==='fixed'||style.position==='sticky')&&r.top<=1&&r.bottom>0&&r.height<200)height=Math.max(height,r.bottom);
      });return height;
    }
    function activate(name){tabs.forEach(function(tab){var on=tab.dataset.ntProductTab===name;tab.classList.toggle('is-active',on);if(on)tab.setAttribute('aria-current','location');else tab.removeAttribute('aria-current');});}
    function go(name){var i=names.indexOf(name);if(i<0||tabs[i].hidden||panels[i].hidden)return;var offset=headerHeight();nav.style.top=offset+'px';
      window.scrollTo({top:Math.max(0,scrollY+panels[i].getBoundingClientRect().top-offset-nav.offsetHeight-16),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      activate(name);
    }
    tabs.forEach(function(tab,i){tab.addEventListener('click',function(){go(names[i]);});tab.addEventListener('keydown',function(e){var visible=tabs.filter(function(t){return !t.hidden;}),index=visible.indexOf(tab),next=e.key==='ArrowRight'?(index+1)%visible.length:e.key==='ArrowLeft'?(index+visible.length-1)%visible.length:e.key==='Home'?0:e.key==='End'?visible.length-1:null;if(next!==null&&visible[next]){e.preventDefault();visible[next].focus();go(visible[next].dataset.ntProductTab);}});});
    // Delegate so late-rendered or recomposed rating summaries use the same section navigation.
    root.addEventListener('click',function(e){
      var link=e.target.closest&&e.target.closest('a[href="#reviews"],.nt-pdp__rating,.nt-pc-review');
      if(!link||!root.contains(link))return;
      e.preventDefault();e.stopImmediatePropagation();go('reviews');
    },true);
    var queued=false;
    function update(){queued=false;var offset=headerHeight();nav.style.top=offset+'px';var active=0;panels.forEach(function(panel,i){if(!panel.hidden&&panel.getBoundingClientRect().top<=offset+nav.offsetHeight+40)active=i;});activate(names[active]);}
    function schedule(){if(!queued){queued=true;requestAnimationFrame(update);}}
    window.addEventListener('scroll',schedule,{passive:true});window.addEventListener('resize',schedule);update();
    if(location.hash==='#reviews')requestAnimationFrame(function(){go('reviews');});
  }

  function initProductReviewList(root) {
    var section = root.querySelector('[data-nt-product-reviews]');
    if (!section || section.dataset.ntReviewsInitialized === 'true') return;
    section.dataset.ntReviewsInitialized = 'true';

    var savedLikes = [];
    try { savedLikes = JSON.parse(localStorage.getItem('nt-product-review-helpful') || '[]'); } catch (_error) { savedLikes = []; }
    section.querySelectorAll('[data-nt-product-review-item]').forEach(function (review) {
      var button = review.querySelector('[data-nt-review-helpful]');
      if (!button) return;
      var id = review.dataset.reviewId;
      var baseLikes = Number(review.dataset.likes || 0);

      function render() {
        var liked = savedLikes.indexOf(id) !== -1;
        button.classList.toggle('is-liked', liked);
        button.setAttribute('aria-pressed', String(liked));
        var count = button.querySelector('b');
        if (count) count.textContent = String(baseLikes + (liked ? 1 : 0));
      }

      button.addEventListener('click', function () {
        savedLikes = savedLikes.indexOf(id) !== -1
          ? savedLikes.filter(function (item) { return item !== id; })
          : savedLikes.concat(id);
        localStorage.setItem('nt-product-review-helpful', JSON.stringify(savedLikes));
        render();
      });
      render();
    });
  }

  function applyProductFitment(root) {
    var payload = root.querySelector('[data-nt-fitment-source]');
    var source = {};
    try { source = JSON.parse(payload && payload.textContent || '{}'); } catch (_error) {}
    var labels = source.labels || {};
    var state = window.NTProductFitment ? window.NTProductFitment.resolve(source) : {status:'review',brand:'',models:[],entries:[],summary:'',yearLabel:''};
    var signature = JSON.stringify([state.status,state.brand,state.summary,state.models]);
    var changed = root.dataset.fitmentSignature !== signature;
    root.dataset.fitmentSignature = signature;
    root.ntFitmentSource = state;
    root.dataset.fitmentStatus = state.status;
    root.dataset.fitmentLabel = (state.status === 'review' ? labels.review_title : labels.title) || 'Fitment check required';
    root.dataset.fitmentModelYears = state.status === 'complete' ? state.summary : '';
    root.dataset.fitmentBrand = state.brand || '';
    root.dataset.fitmentReviewNotice = labels.review_notice || '';
    var review=root.querySelector('[data-nt-fitment-review]');if(review)review.hidden=state.status !== 'review';
    if (state.status === 'customer' || state.status === 'not_required') return;
    function set(selector, value) { var el=root.querySelector(selector); if(el)el.textContent=value || labels.missing || ''; }
    set('[data-nt-fitment-brand]',state.brand);
    set('[data-nt-fitment-model]',state.models.join(' / '));
    var years = root.querySelector('[data-nt-fitment-year]');
    if (years) {
      years.replaceChildren();
      if (state.status === 'complete') {
        state.entries.forEach(function(entry) {
          var row=document.createElement('span');row.style.display='block';
          row.textContent=state.entries.length > 1 ? entry.model+' ('+entry.yearLabel+')' : entry.yearLabel;
          years.appendChild(row);
        });
      } else years.textContent=labels.missing || '';
    }
    [['brand',state.brand],['model',state.models.join(' / ')],['year',state.status === 'complete' ? state.yearLabel : '']].forEach(function(item) {
      var input=root.querySelector('[data-nt-fitment-'+item[0]+'-input]');if(input)input.value=item[1] || '';
    });
    var field=root.querySelector('[data-nt-fitment]');
    if(field){var legend=field.querySelector('legend');if(legend)legend.textContent=root.dataset.fitmentLabel || '';}
    if(state.status === 'review')set('[data-nt-fitment-confirm-label]',labels.review_acknowledgement);
    var guide=root.querySelector('[data-nt-fitment-guide]');
    if(guide){
      guide.hidden=false;
      var status=guide.querySelector('[data-nt-fitment-guide-status]');if(status)status.textContent=root.dataset.fitmentLabel || '';
      var warning=guide.querySelector('[data-nt-fitment-guide-warning]');if(warning)warning.hidden=state.status !== 'review';
      var warningText=guide.querySelector('[data-nt-fitment-guide-warning-text]');if(warningText)warningText.textContent=labels.review_notice || '';
    }
    if(changed)root.dispatchEvent(new CustomEvent('nt:fitment:resolved'));
  }

  function initOwnerReviews(root) {
    if(root.ntOwnerReviewsWatcher)return;
    var activeHost=null,countObserver=null,link=null,treeObserver;
    function sync(){
      if(!activeHost||!link)return;
      var count=Number(activeHost.dataset.reviewCount),hasReviews=Number.isInteger(count)&&count>0;
      link.hidden=!hasReviews;
      link.querySelector('[data-nt-top-review-count]').textContent=hasReviews?count+(count===1?' Review':' Reviews'):'';
      var panel=root.querySelector('[data-nt-product-panel="reviews"]'),tab=root.querySelector('[data-nt-product-tab="reviews"]');
      if(panel)panel.hidden=!hasReviews;
      if(tab){
        if(!hasReviews&&(tab.getAttribute('aria-selected')==='true'||tab.getAttribute('aria-current')==='location'))root.querySelector('[data-nt-product-tab="description"]')?.click();
        tab.hidden=!hasReviews;
      }
    }
    function attach(){
      var host=root.querySelector('[data-nt-owner-reviews]');
      if(!host||host===activeHost)return;
      if(countObserver)countObserver.disconnect();
      activeHost=host;link=root.querySelector('.nt-pdp__rating');if(!link)return;
      sync();countObserver=new MutationObserver(sync);countObserver.observe(host,{attributes:true,attributeFilter:['data-review-count']});
      if(window.NTLoadOwnerReviews)window.NTLoadOwnerReviews().then(function(module){if(root.isConnected&&host===activeHost){module.mount(host);sync();}}).catch(function(){});
    }
    treeObserver=new MutationObserver(attach);treeObserver.observe(root,{childList:true,subtree:true});root.ntOwnerReviewsWatcher=treeObserver;
    root.addEventListener('nt:product:unload',function(){treeObserver.disconnect();if(countObserver)countObserver.disconnect();activeHost=null;},{once:true});
    attach();
  }

  function initProduct(root) {
    applyProductFitment(root);
    initOwnerReviews(root);
    if (root.dataset.ntProductInitialized === 'true') return;
    root.dataset.ntProductInitialized = 'true';
    var lifetime=new AbortController();
    function listenGlobal(target,type,handler,options){target.addEventListener(type,handler,Object.assign({},options,{signal:lifetime.signal}));}
    root.addEventListener('nt:product:unload',function(){lifetime.abort();availabilityRun++;root.dispatchEvent(new Event('shopify:section:unload'));window.clearTimeout(addedLabelTimer);},{once:true});
    document.documentElement.classList.add('nt-pdp-has-product-page');

    var mainImage = root.querySelector('[data-nt-main-image]');
    var gallery = root.querySelector('[data-nt-product-gallery]');
    var galleryPrevious = root.querySelector('[data-nt-gallery-prev]');
    var galleryNext = root.querySelector('[data-nt-gallery-next]');
    var thumbnailTrack = root.querySelector('[data-nt-gallery-thumbs]');
    var thumbnailsPrevious = root.querySelector('[data-nt-thumbs-prev]');
    var thumbnailsNext = root.querySelector('[data-nt-thumbs-next]');
    var imageCount = root.querySelector('[data-nt-image-count]');
    var thumbnails = Array.from(root.querySelectorAll('[data-nt-product-thumb]'));
    var activeImageIndex = Math.max(0, thumbnails.findIndex(function (button) {
      return button.classList.contains('is-active');
    }));
    var thumbnailShell = thumbnailTrack && thumbnailTrack.closest('.nt-pdp__thumbs-shell');
    var thumbnailFrame = 0;
    var thumbnailResizeObserver;
    var thumbnailMutationObserver;

    function verticalThumbnails() {
      return thumbnailTrack && getComputedStyle(thumbnailTrack).flexDirection === 'column';
    }

    function revealThumbnail(button) {
      if (!thumbnailTrack || !button || !thumbnailTrack.clientHeight) return;
      var vertical = verticalThumbnails();
      var trackRect = thumbnailTrack.getBoundingClientRect();
      var buttonRect = button.getBoundingClientRect();
      var start = vertical ? buttonRect.top - trackRect.top : buttonRect.left - trackRect.left;
      var end = vertical ? buttonRect.bottom - trackRect.bottom : buttonRect.right - trackRect.right;
      var distance = start < 0 ? start : end > 0 ? end : 0;
      if (distance) thumbnailTrack.scrollBy({
        top: vertical ? distance : 0,
        left: vertical ? 0 : distance,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }

    function updateThumbnails() {
      thumbnailFrame = 0;
      if (!thumbnailShell || !gallery) return;
      var height = Math.floor(gallery.getBoundingClientRect().height);
      if (height > 0) thumbnailShell.style.setProperty('--nt-gallery-height', height + 'px');
      var vertical = verticalThumbnails();
      var first = thumbnailTrack.firstElementChild;
      var last = thumbnailTrack.lastElementChild;
      var contentSize = 0;
      if (first && last) {
        var firstRect = first.getBoundingClientRect();
        var lastRect = last.getBoundingClientRect();
        contentSize = vertical ? lastRect.bottom - firstRect.top : lastRect.right - firstRect.left;
      }
      var available = vertical ? height : thumbnailShell.clientWidth;
      var overflow = contentSize > available + 1;
      thumbnailShell.classList.toggle('nt-thumbs-has-overflow', overflow);
      var position = vertical ? thumbnailTrack.scrollTop : thumbnailTrack.scrollLeft;
      var maximum = vertical ? thumbnailTrack.scrollHeight - thumbnailTrack.clientHeight : thumbnailTrack.scrollWidth - thumbnailTrack.clientWidth;
      if (thumbnailsPrevious) thumbnailsPrevious.disabled = !overflow || position <= 1;
      if (thumbnailsNext) thumbnailsNext.disabled = !overflow || position >= maximum - 1;
    }

    function queueThumbnails() {
      if (!thumbnailFrame) thumbnailFrame = window.requestAnimationFrame(updateThumbnails);
    }

    function scrollThumbnails(direction) {
      var vertical = verticalThumbnails();
      var first = thumbnailTrack.firstElementChild;
      var size = first ? (vertical ? first.offsetHeight : first.offsetWidth) : 68;
      var gap = parseFloat(getComputedStyle(thumbnailTrack).gap) || 0;
      var step = size + gap;
      var visible = vertical ? thumbnailTrack.clientHeight : thumbnailTrack.clientWidth;
      var distance = direction * Math.max(1, Math.floor(visible / step) - 1) * step;
      thumbnailTrack.scrollBy({
        top: vertical ? distance : 0,
        left: vertical ? 0 : distance,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }

    if (thumbnailShell && gallery) {
      thumbnailShell.classList.add('nt-thumbs-enhanced');
      [thumbnailsPrevious, thumbnailsNext].forEach(function (button, index) {
        if (!button) return;
        var label = index ? root.dataset.thumbnailsNextLabel : root.dataset.thumbnailsPreviousLabel;
        if (label) button.setAttribute('aria-label', label);
        var icon = document.createElement('i');
        icon.className = index ? 'fa fa-angle-right' : 'fa fa-angle-left';
        icon.setAttribute('aria-hidden', 'true');
        button.replaceChildren(icon);
      });
      thumbnailTrack.addEventListener('scroll', queueThumbnails, { passive: true });
      listenGlobal(window,'resize', queueThumbnails, { passive: true });
      thumbnailResizeObserver = new ResizeObserver(queueThumbnails);
      thumbnailResizeObserver.observe(gallery);
      thumbnailResizeObserver.observe(thumbnailTrack);
      thumbnailMutationObserver = new MutationObserver(function (records) {
        queueThumbnails();
        if (records.some(function (record) { return record.type === 'attributes'; })) {
          revealThumbnail(thumbnailTrack.querySelector('.is-active'));
        }
      });
      thumbnailMutationObserver.observe(thumbnailTrack, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
      root.addEventListener('shopify:section:unload', function () {
        window.cancelAnimationFrame(thumbnailFrame);
        window.removeEventListener('resize', queueThumbnails);
        thumbnailResizeObserver.disconnect();
        thumbnailMutationObserver.disconnect();
      });
      queueThumbnails();
    }

    function setMainImage(imageUrl, imageAlt) {
      if (!mainImage || !imageUrl) return;

      // The original responsive srcset otherwise overrides a newly assigned src.
      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');
      mainImage.src = imageUrl;
      mainImage.alt = imageAlt || root.dataset.productTitle || '';
    }

    function selectImage(index, shouldFocus) {
      if (!thumbnails.length) return;
      var normalizedIndex = (index + thumbnails.length) % thumbnails.length;
      var button = thumbnails[normalizedIndex];

      activeImageIndex = normalizedIndex;
      setMainImage(button.dataset.image, button.dataset.alt);
      if (imageCount) {
        var currentCount = imageCount.querySelector('b');
        if (currentCount) currentCount.textContent = String(normalizedIndex + 1);
        imageCount.setAttribute('aria-label', 'Image ' + (normalizedIndex + 1) + ' of ' + thumbnails.length);
      }
      thumbnails.forEach(function (item, itemIndex) {
        var isActive = itemIndex === normalizedIndex;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      revealThumbnail(button);
      if (shouldFocus) button.focus({ preventScroll: true });
    }

    thumbnails.forEach(function (button, index) {
      button.addEventListener('click', function () {
        selectImage(index, false);
      });
    });

    if (galleryPrevious) galleryPrevious.addEventListener('click', function () { selectImage(activeImageIndex - 1, false); });
    if (galleryNext) galleryNext.addEventListener('click', function () { selectImage(activeImageIndex + 1, false); });
    if (thumbnailTrack && thumbnailsPrevious) thumbnailsPrevious.addEventListener('click', function () {
      scrollThumbnails(-1);
    });
    if (thumbnailTrack && thumbnailsNext) thumbnailsNext.addEventListener('click', function () {
      scrollThumbnails(1);
    });

    if (gallery && thumbnails.length > 1) {
      var pointerStartX = 0;
      var pointerStartY = 0;
      var activePointerId = null;

      gallery.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        activePointerId = event.pointerId;
        pointerStartX = event.clientX;
        pointerStartY = event.clientY;
      });

      gallery.addEventListener('pointerup', function (event) {
        if (activePointerId !== event.pointerId) return;
        var deltaX = event.clientX - pointerStartX;
        var deltaY = event.clientY - pointerStartY;
        activePointerId = null;

        if (Math.abs(deltaX) < 45 || Math.abs(deltaX) <= Math.abs(deltaY) * 1.15) return;
        selectImage(activeImageIndex + (deltaX < 0 ? 1 : -1), false);
      });

      gallery.addEventListener('pointercancel', function () {
        activePointerId = null;
      });

      gallery.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        selectImage(activeImageIndex + (event.key === 'ArrowRight' ? 1 : -1), false);
      });
    }

    function normalizeVehicleText(value) {
      return String(value || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
    }

    var variantSelect = root.querySelector('[data-nt-variant-select]');
    var price = root.querySelector('[data-nt-price]');
    var couponPrice = root.querySelector('[data-nt-coupon-price]');
    var compare = root.querySelector('[data-nt-compare-price]');
    var discountPercent = root.querySelector('[data-nt-discount-percent]');
    var addButton = root.querySelector('[data-nt-add-to-cart]');
    var addLabel = root.querySelector('[data-nt-add-label]');
    var buyNowButton = root.querySelector('[data-nt-buy-now]');
    var buyNowLabel = root.querySelector('[data-nt-buy-label]');
    var productForm = addButton && (addButton.form || addButton.closest('form') || root.querySelector('form[action*="/cart/add"]'));
    var mobileAddButton = document.querySelector('[data-nt-mobile-add]');
    var mobileAddLabel = document.querySelector('[data-nt-mobile-add-label]');
    var mobileCartButton = document.querySelector('[data-nt-mobile-cart]');
    var purchaseBusy = false;
    var addedLabelTimer;
    var fitmentSelectionsComplete = false;
    var selectedVariantAvailable = root.dataset.currentAvailable === 'true';
    var unavailableLabel = root.dataset.unavailableLabel || 'UNAVAILABLE';
    var unavailableNote = root.dataset.unavailableNote || 'This product option is currently unavailable. Contact us to check availability and shipping options.';

    function updateAvailabilityNotice() {
      root.querySelectorAll('[data-nt-availability-details]').forEach(function (element) {
        element.hidden = !selectedVariantAvailable;
      });
      root.querySelectorAll('[data-nt-unavailable-notice]').forEach(function (element) {
        element.hidden = selectedVariantAvailable;
      });
      root.querySelectorAll('[data-nt-unavailable-heading]').forEach(function (element) {
        element.textContent = unavailableLabel;
      });
      root.querySelectorAll('[data-nt-unavailable-message]').forEach(function (element) {
        element.textContent = unavailableNote;
      });
    }
    var shippingEstimateLabel = root.querySelector('[data-nt-shipping-estimate]');
    var shippingEstimatePill = shippingEstimateLabel && shippingEstimateLabel.closest('.nt-pdp__mobile-fact');
    var shippingEstimateTimer = null;
    var shippingEstimateRun = 0;

    function getShopifyRoot() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    function getSelectedVariantId() {
      if (variantSelect) return variantSelect.value;
      var idInput = productForm && productForm.querySelector('input[name="id"]');
      return idInput ? idInput.value : '';
    }

    function formatShippingPrice(price) {
      var amount = Number(price);
      if (!Number.isFinite(amount)) amount = Number(String(price || '').replace(/[^0-9.]/g, ''));
      var currency = root.dataset.moneyCurrency || 'USD';
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(amount);
      } catch (error) {
        return '$' + amount.toFixed(2);
      }
    }

    function setShippingEstimate(text) {
      if (!shippingEstimateLabel || !shippingEstimatePill) return;
      if (!text) {
        shippingEstimateLabel.textContent = '';
        shippingEstimatePill.hidden = true;
        return;
      }
      shippingEstimateLabel.textContent = text;
      shippingEstimatePill.hidden = false;
    }

    function effectiveShippingDestination() {
      var countryCode = String(root.dataset.shippingCountryCode || '').toUpperCase();
      var country = root.dataset.shippingCountry || '';
      var province = String(root.dataset.shippingProvince || '').toUpperCase();
      var zip = root.dataset.shippingZip || '';
      return { countryCode: countryCode, country: country, province: province, zip: zip };
    }

    function applyKnownShippingPolicy() {
      var destination = effectiveShippingDestination();
      var fulfillment = root.dataset.fulfillment || '';
      if (!selectedVariantAvailable) {
        setShippingEstimate('Shipping calculated at checkout');
        return true;
      }
      if ((fulfillment === 'us' || fulfillment === 'preorder') && destination.countryCode === 'US') {
        setShippingEstimate(destination.province === 'AK' || destination.province === 'HI' ? 'Shipping only $400' : 'Free shipping');
        return true;
      }
      if ((fulfillment === 'us' || fulfillment === 'preorder') && (destination.countryCode === 'CA' || destination.countryCode === 'MX')) {
        setShippingEstimate('Shipping only $200');
        return true;
      }
      if (fulfillment === 'china') {
        setShippingEstimate('Shipping only $100');
        return true;
      }
      return false;
    }

    function queueShippingEstimate() {
      if (!shippingEstimateLabel) return;
      if (applyKnownShippingPolicy()) return;
      setShippingEstimate('Shipping calculated at checkout');
    }

    function updateVariant() {
      if (!variantSelect) return;
      var option = variantSelect.options[variantSelect.selectedIndex];
      selectedVariantAvailable = option && option.dataset.available === 'true';
      unavailableLabel = option && option.dataset.unavailableLabel || 'UNAVAILABLE';
      unavailableNote = option && option.dataset.unavailableNote || 'This product option is currently unavailable. Contact us to check availability and shipping options.';
      var currentCurrency = window.NTRedesignCurrency && window.NTRedesignCurrency.current ? window.NTRedesignCurrency.current() : '';
      if (option && price) {
        price.dataset.ntMoneyCents = option.dataset.priceCents || '';
        price.innerHTML = window.NTRedesignCurrency && option.dataset.priceCents
          ? window.NTRedesignCurrency.format(Number(option.dataset.priceCents), currentCurrency, price.dataset.ntMoneyBase)
          : option.dataset.price || '';
      }
      if (option && couponPrice) {
        couponPrice.dataset.ntMoneyCents = option.dataset.couponPriceCents || '';
        couponPrice.innerHTML = window.NTRedesignCurrency && option.dataset.couponPriceCents
          ? window.NTRedesignCurrency.format(Number(option.dataset.couponPriceCents), currentCurrency, couponPrice.dataset.ntMoneyBase)
          : option.dataset.couponPrice || '';
      }
      if (compare) {
        compare.dataset.ntMoneyCents = option ? option.dataset.comparePriceCents || '' : '';
        compare.innerHTML = window.NTRedesignCurrency && option && option.dataset.comparePriceCents
          ? window.NTRedesignCurrency.format(Number(option.dataset.comparePriceCents), currentCurrency, compare.dataset.ntMoneyBase)
          : (option ? option.dataset.comparePrice || '' : '');
        compare.hidden = !option || !option.dataset.comparePrice;
      }
      if (discountPercent) {
        var priceCents = Number(option && option.dataset.priceCents || 0);
        var compareCents = Number(option && option.dataset.comparePriceCents || 0);
        var hasDiscount = compareCents > priceCents && priceCents >= 0;
        discountPercent.hidden = !hasDiscount;
        discountPercent.textContent = hasDiscount ? '-' + Math.round((compareCents - priceCents) * 100 / compareCents) + '%' : '';
      }
      if (option && option.dataset.image && mainImage) {
        var variantImage = option.dataset.image;
        var matchingIndex = thumbnails.findIndex(function (button) {
          return button.dataset.image === variantImage;
        });
        if (matchingIndex >= 0) selectImage(matchingIndex, false);
        else setMainImage(variantImage, root.dataset.productTitle || '');
      }
      if (addLabel && !selectedVariantAvailable) addLabel.textContent = unavailableLabel;
      updateFitment();
      queueShippingEstimate();
    }

    var confirmed = root.querySelector('[data-nt-fitment-confirm]');
    var note = root.querySelector('[data-nt-fitment-note]');
    var fitment = root.querySelector('[data-nt-fitment]');
    var customerSelectsFitment = Boolean(fitment && fitment.dataset.customerSelectsFitment === 'true');
    var brandSelect = root.querySelector('[data-nt-fitment-brand-select]');
    var modelSelect = root.querySelector('[data-nt-fitment-model-select]');
    var yearSelect = root.querySelector('[data-nt-fitment-year-select]');
    var brandOther = root.querySelector('[data-nt-fitment-brand-other]');
    var modelOther = root.querySelector('[data-nt-fitment-model-other]');
    var yearOther = root.querySelector('[data-nt-fitment-year-other]');
    var brandInput = root.querySelector('[data-nt-fitment-brand-input]');
    var modelInput = root.querySelector('[data-nt-fitment-model-input]');
    var yearInput = root.querySelector('[data-nt-fitment-year-input]');

    function setOptions(select, placeholder, values) {
      if (!select) return;
      select.innerHTML = '';
      var prompt = document.createElement('option');
      prompt.value = '';
      prompt.textContent = placeholder;
      select.appendChild(prompt);
      values.forEach(function (value) {
        var option = document.createElement('option');
        option.value = value;
        option.textContent = value;
        select.appendChild(option);
      });
      var otherOption = document.createElement('option');
      otherOption.value = 'Other';
      otherOption.textContent = 'Other';
      select.appendChild(otherOption);
    }

    function toggleOther(select, input) {
      if (!select || !input) return '';
      var isOther = select.value === 'Other';
      input.hidden = !isOther;
      input.disabled = !isOther;
      input.required = isOther;
      if (!isOther) input.value = '';
      return isOther ? input.value.trim() : select.value;
    }

    function resetConfirmation() {
      if (confirmed) confirmed.checked = false;
    }

    function syncCustomerFitment() {
      if (!customerSelectsFitment) return;
      var brand = toggleOther(brandSelect, brandOther);
      var model = toggleOther(modelSelect, modelOther);
      var year = toggleOther(yearSelect, yearOther);
      if (brandInput) brandInput.value = brand;
      if (modelInput) modelInput.value = model;
      if (yearInput) yearInput.value = year;
    }

    function populateModels() {
      if (!brandSelect || !modelSelect || !yearSelect) return;
      var brand = brandSelect.value;
      var options = window.NTVehicleOptions || {};
      var models = brand && brand !== 'Other' ? Object.keys(options[brand] || {}).sort() : [];
      setOptions(modelSelect, 'Choose model', models);
      modelSelect.disabled = !brand;
      setOptions(yearSelect, 'Choose year', []);
      yearSelect.disabled = true;
      if (brand === 'Other') {
        modelSelect.value = 'Other';
        yearSelect.disabled = false;
        yearSelect.value = 'Other';
      }
      resetConfirmation();
      syncCustomerFitment();
      updateFitment();
    }

    function populateYears() {
      if (!brandSelect || !modelSelect || !yearSelect) return;
      var options = window.NTVehicleOptions || {};
      var years = modelSelect.value && modelSelect.value !== 'Other'
        ? (options[brandSelect.value] && options[brandSelect.value][modelSelect.value] || [])
        : [];
      setOptions(yearSelect, 'Choose year', years);
      yearSelect.disabled = !modelSelect.value;
      if (modelSelect.value === 'Other') yearSelect.value = 'Other';
      resetConfirmation();
      syncCustomerFitment();
      updateFitment();
    }

    function initializeCustomerFitment() {
      if (!customerSelectsFitment || !brandSelect) return;
      setOptions(brandSelect, 'Choose brand', Object.keys(window.NTVehicleOptions || {}).sort());
      setOptions(modelSelect, 'Choose model', []);
      setOptions(yearSelect, 'Choose year', []);
      modelSelect.disabled = true;
      yearSelect.disabled = true;
      syncCustomerFitment();
    }

    function setPurchaseBusy(intent, busy) {
      purchaseBusy = busy;
      var label = intent === 'checkout'
        ? (busy ? 'OPENING CHECKOUT...' : 'BUY NOW')
        : (busy ? 'ADDING...' : 'ADD TO CART');
      if (intent === 'checkout') {
        if (buyNowLabel) buyNowLabel.textContent = label;
        if (mobileAddLabel) mobileAddLabel.textContent = label;
        if (buyNowButton) {
          buyNowButton.disabled = busy || !fitmentSelectionsComplete || !selectedVariantAvailable;
          if (busy) buyNowButton.setAttribute('aria-busy', 'true');
          else buyNowButton.removeAttribute('aria-busy');
        }
        if (mobileAddButton) {
          mobileAddButton.disabled = busy || !fitmentSelectionsComplete || !selectedVariantAvailable;
          if (busy) mobileAddButton.setAttribute('aria-busy', 'true');
          else mobileAddButton.removeAttribute('aria-busy');
        }
      } else {
        if (addLabel) addLabel.textContent = label;
        if (addButton) {
          addButton.disabled = busy || !fitmentSelectionsComplete || !selectedVariantAvailable;
          if (busy) addButton.setAttribute('aria-busy', 'true');
          else addButton.removeAttribute('aria-busy');
        }
        if (mobileCartButton) {
          mobileCartButton.disabled = busy || !fitmentSelectionsComplete || !selectedVariantAvailable;
          if (busy) mobileCartButton.setAttribute('aria-busy', 'true');
          else mobileCartButton.removeAttribute('aria-busy');
        }
      }
      [addButton, buyNowButton, mobileCartButton, mobileAddButton].forEach(function (button) {
        if (button) button.disabled = busy || !fitmentSelectionsComplete || !selectedVariantAvailable;
      });
    }

    function addSelectedItem(intent) {
      if (purchaseBusy || (window.NTCart && window.NTCart.busy) || !productForm || !selectedVariantAvailable || !fitmentSelectionsComplete) return;
      window.clearTimeout(addedLabelTimer);
      var formData = new FormData(productForm);
      formData.delete('properties[Fitment confirmed]');
      if (fitment && root.dataset.fitmentStatus === 'review') {
        formData.set('properties[Fitment review required]', 'Yes');
      } else if (fitment && confirmed && confirmed.checked) {
        formData.set('properties[Fitment confirmed]', 'Yes');
      }
      setPurchaseBusy(intent, true);
      if (note) note.textContent = intent === 'checkout' ? 'Opening secure Shopify checkout...' : 'Adding the selected item...';

      var request = window.NTCart ? window.NTCart.add(formData) : fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      }).then(function (response) {
        if (!response.ok) return response.json().then(function (payload) { throw new Error(payload.description || payload.message || 'Unable to add this item.'); });
        return response.json();
      });
      request.then(function (payload) {
        if (intent === 'checkout') {
          window.location.assign(getShopifyRoot() + 'checkout');
          return;
        }
        if (!window.NTCart) { window.location.assign(getShopifyRoot() + 'cart'); return; }
        setPurchaseBusy('cart', false);
        if (note) note.textContent = payload.ntSyncWarning || 'Added to cart. Continue shopping or open the cart when ready.';
        if (addLabel) addLabel.textContent = 'ADDED';
        addedLabelTimer = window.setTimeout(function () { if (addLabel && !purchaseBusy) addLabel.textContent = 'ADD TO CART'; }, 1800);
      }).catch(function (error) {
        setPurchaseBusy(intent, false);
        if (note) note.textContent = error.message || 'Unable to continue. Please try again.';
      });
    }

    function updateFitment() {
      updateAvailabilityNotice();
      syncCustomerFitment();
      fitmentSelectionsComplete = !customerSelectsFitment || Boolean(
        brandInput && brandInput.value.trim() &&
        modelInput && modelInput.value.trim() &&
        yearInput && yearInput.value.trim()
      );
      if (purchaseBusy) return;
      if (addButton) addButton.disabled = !fitmentSelectionsComplete || !selectedVariantAvailable;
      if (addLabel) addLabel.textContent = selectedVariantAvailable ? 'ADD TO CART' : unavailableLabel;
      if (buyNowButton) buyNowButton.disabled = !fitmentSelectionsComplete || !selectedVariantAvailable;
      if (buyNowLabel) buyNowLabel.textContent = selectedVariantAvailable ? 'BUY NOW' : unavailableLabel;
      if (mobileCartButton) mobileCartButton.disabled = !fitmentSelectionsComplete || !selectedVariantAvailable;
      if (mobileAddButton) {
        mobileAddButton.dataset.ready = fitmentSelectionsComplete && selectedVariantAvailable ? 'true' : 'false';
        mobileAddButton.disabled = !fitmentSelectionsComplete || !selectedVariantAvailable;
        mobileAddButton.setAttribute('aria-label', !selectedVariantAvailable ? unavailableLabel : 'Buy now');
      }
      if (mobileAddLabel) mobileAddLabel.textContent = selectedVariantAvailable ? 'BUY NOW' : unavailableLabel;
      if (note) {
        note.textContent = !selectedVariantAvailable
          ? unavailableNote
          : customerSelectsFitment && !fitmentSelectionsComplete
              ? 'Select your brand, model and year to continue.'
              : root.dataset.fitmentStatus === 'review' ? root.dataset.fitmentReviewNotice : '';
      }
    }

    // Reconcile stale HTML with Shopify's current-session variant availability.
    var availabilityRun = 0;
    function refreshAvailability() {
      var handle=root.dataset.productHandle,id=getSelectedVariantId(),run=++availabilityRun;
      if(!handle||!id)return;
      fetch(getShopifyRoot()+'products/'+encodeURIComponent(handle)+'.js', {credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}})
      .then(function(r){if(!r.ok)throw new Error('Availability check failed');return r.json();})
      .then(function(p){
        if(run!==availabilityRun||getSelectedVariantId()!==id)return;
        var v=(p.variants||[]).find(function(v){return String(v.id)===String(id);});
        if(!v||typeof v.available!=='boolean')return;
        selectedVariantAvailable=v.available;
        root.dataset.currentAvailable=String(v.available);
        root.dataset.ntAvailabilityVerified='true';
        if(variantSelect){var option=variantSelect.options[variantSelect.selectedIndex];if(option)option.dataset.available=String(v.available);}
        updateFitment();queueShippingEstimate();
      }).catch(function(){root.dataset.ntAvailabilityVerified='failed';});
    }
    listenGlobal(window,'pageshow',refreshAvailability);
    if(variantSelect)variantSelect.addEventListener('change',refreshAvailability);
    listenGlobal(document,'visibilitychange',function(){if(document.visibilityState==='visible')refreshAvailability();});
    refreshAvailability();

    initializeCustomerFitment();
    if (brandSelect) brandSelect.addEventListener('change', populateModels);
    if (modelSelect) modelSelect.addEventListener('change', populateYears);
    if (yearSelect) yearSelect.addEventListener('change', function () {
      resetConfirmation();
      syncCustomerFitment();
      updateFitment();
    });
    [brandOther, modelOther, yearOther].forEach(function (input) {
      if (!input) return;
      input.addEventListener('input', function () {
        resetConfirmation();
        syncCustomerFitment();
        updateFitment();
      });
    });
    if (confirmed) confirmed.addEventListener('change', updateFitment);
    if (variantSelect) variantSelect.addEventListener('change', updateVariant);
    if (productForm) productForm.addEventListener('submit', function (event) { event.preventDefault(); });
    if (addButton) addButton.addEventListener('click', function () { addSelectedItem('cart'); });
    if (buyNowButton) buyNowButton.addEventListener('click', function () { addSelectedItem('checkout'); });
    if (mobileCartButton) mobileCartButton.addEventListener('click', function () { addSelectedItem('cart'); });
    if (mobileAddButton) mobileAddButton.addEventListener('click', function () { addSelectedItem('checkout'); });
    updateVariant();
    updateFitment();
    queueShippingEstimate();

    var saveToggle = root.querySelector('[data-nt-save-toggle]');
    var saveLabel = root.querySelector('[data-nt-save-label]');
    var mobileLikeToggle = document.querySelector('[data-nt-mobile-like]');
    var mobileLikeLabel = root.querySelector('[data-nt-mobile-like-label]');
    if (!mobileLikeLabel) mobileLikeLabel = document.querySelector('[data-nt-mobile-like-label]');
    var savedProductsKey = 'nt-fairing:saved-products';
    var productHandle = root.dataset.productHandle || '';

    function getSavedProducts() {
      try {
        var saved = JSON.parse(window.localStorage.getItem(savedProductsKey) || '{}');
        return saved && typeof saved === 'object' && !Array.isArray(saved) ? saved : {};
      } catch (error) {
        return {};
      }
    }

    function setSaveState(saved) {
      if (saveToggle) {
        saveToggle.setAttribute('aria-pressed', saved ? 'true' : 'false');
        saveToggle.setAttribute('aria-label', saved ? 'Unlike this product' : 'Like this product');
      }
      if (saveLabel) saveLabel.textContent = saved ? 'LIKED' : 'LIKE';
      if (mobileLikeToggle) {
        mobileLikeToggle.setAttribute('aria-pressed', saved ? 'true' : 'false');
        mobileLikeToggle.setAttribute('aria-label', saved ? 'Unlike this product' : 'Like this product');
      }
      if (mobileLikeLabel) mobileLikeLabel.textContent = saved ? 'LIKED' : 'LIKE';
    }

    function toggleSavedProduct() {
      if (!productHandle) return;
      var products = getSavedProducts();
      var isSaved = Boolean(products[productHandle]);

      if (isSaved) {
        delete products[productHandle];
      } else {
        products[productHandle] = {
          handle: productHandle,
          title: root.dataset.productTitle || document.title,
          url: root.dataset.productUrl || window.location.href,
          image: root.dataset.productImage || ''
        };
      }

      try { window.localStorage.setItem(savedProductsKey, JSON.stringify(products)); }
      catch (error) {}
      setSaveState(!isSaved);
    }

    if (productHandle) setSaveState(Boolean(getSavedProducts()[productHandle]));
    if (saveToggle && productHandle) {
      saveToggle.addEventListener('click', toggleSavedProduct);
    }
    if (mobileLikeToggle && productHandle) mobileLikeToggle.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      toggleSavedProduct();
    });

    var shareToggle = root.querySelector('[data-nt-share-toggle]');
    var mobileShareToggle = document.querySelector('[data-nt-mobile-share]');
    var shareMenu = root.querySelector('[data-nt-share-menu]');
    var shareLabel = root.querySelector('[data-nt-share-label]');
    var shareWrap = root.querySelector('.nt-pdp__share');
    var shareQr = root.querySelector('[data-nt-share-qr]');
    var shareQrUrl = '';

    function getShareUrl() {
      var url = new URL(root.dataset.productUrl || window.location.href, window.location.origin);
      var removable = ['preview_theme_id', '_pos', '_sid', '_ss', 'fbclid', 'gclid'];
      Array.from(url.searchParams.keys()).forEach(function (key) {
        if (removable.indexOf(key) !== -1 || key.toLowerCase().indexOf('utm_') === 0) url.searchParams.delete(key);
      });
      return url.toString();
    }

    function setShareMenu(open) {
      if (!shareToggle || !shareMenu) return;
      shareToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      shareMenu.hidden = !open;
    }

    function updateShareLinks() {
      var url = getShareUrl();
      var title = root.dataset.productTitle || document.title;
      var image = root.dataset.productImage || '';
      root.querySelectorAll('[data-nt-share-network]').forEach(function (link) {
        var network = link.dataset.ntShareNetwork;
        if (network === 'facebook') link.href = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url);
        if (network === 'instagram') {
          link.href = 'https://www.instagram.com/';
          link.dataset.ntCopyBeforeOpen = 'true';
        }
        if (network === 'tiktok') {
          link.href = 'https://www.tiktok.com/';
          link.dataset.ntCopyBeforeOpen = 'true';
        }
        if (network === 'x') link.href = 'https://x.com/intent/post?url=' + encodeURIComponent(url) + '&text=' + encodeURIComponent(title);
        if (network === 'reddit') link.href = 'https://www.reddit.com/submit?url=' + encodeURIComponent(url) + '&title=' + encodeURIComponent(title);
        if (network === 'pinterest') link.href = 'https://pinterest.com/pin/create/button/?url=' + encodeURIComponent(url) + '&media=' + encodeURIComponent(image) + '&description=' + encodeURIComponent(title);
        if (network === 'whatsapp') link.href = 'https://wa.me/?text=' + encodeURIComponent(title + ' ' + url);
        if (network === 'email') link.href = 'mailto:?subject=' + encodeURIComponent(title) + '&body=' + encodeURIComponent(url);
      });

      if (shareQr && window.QRCode && shareQrUrl !== url) {
        shareQr.innerHTML = '';
        new window.QRCode(shareQr, {
          text: url,
          width: 144,
          height: 144,
          colorDark: '#111315',
          colorLight: '#ffffff',
          correctLevel: window.QRCode.CorrectLevel.M
        });
        shareQrUrl = url;
      }
    }

    function copyShareUrl() {
      var url = getShareUrl();
      var copied = navigator.clipboard && window.isSecureContext
        ? navigator.clipboard.writeText(url)
        : new Promise(function (resolve, reject) {
            var field = document.createElement('textarea');
            field.value = url;
            field.setAttribute('readonly', '');
            field.style.position = 'fixed';
            field.style.opacity = '0';
            document.body.appendChild(field);
            field.select();
            try { document.execCommand('copy') ? resolve() : reject(); }
            catch (error) { reject(error); }
            document.body.removeChild(field);
          });

      copied.then(function () {
        if (shareLabel) shareLabel.textContent = 'LINK COPIED';
        setShareMenu(false);
        window.setTimeout(function () { if (shareLabel) shareLabel.textContent = 'SHARE'; }, 1800);
      }).catch(function () {
        if (shareLabel) shareLabel.textContent = 'COPY FAILED';
        window.setTimeout(function () { if (shareLabel) shareLabel.textContent = 'SHARE'; }, 1800);
      });
    }

    if (shareToggle && shareMenu) {
      updateShareLinks();
      shareToggle.addEventListener('click', function () {
        if (navigator.share && !window.matchMedia('(min-width: 1024px)').matches) {
          navigator.share({
            title: root.dataset.productTitle || document.title,
            text: root.dataset.productTitle || document.title,
            url: getShareUrl()
          }).catch(function (error) {
            if (error && error.name !== 'AbortError') setShareMenu(true);
          });
          return;
        }
        setShareMenu(shareMenu.hidden);
      });

      var copyButton = shareMenu.querySelector('[data-nt-share-action="copy"]');
      if (copyButton) copyButton.addEventListener('click', copyShareUrl);
      shareMenu.querySelectorAll('[data-nt-copy-before-open="true"]').forEach(function (link) {
        link.addEventListener('click', function () {
          if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(getShareUrl()).catch(function () {});
        });
      });
      listenGlobal(document,'click', function (event) {
        if (shareWrap && !shareWrap.contains(event.target)) setShareMenu(false);
      });
      listenGlobal(document,'keydown', function (event) {
        if (event.key === 'Escape') setShareMenu(false);
      });
    }
    function openNativeShareOrMenu() {
      if (navigator.share) {
        navigator.share({
          title: root.dataset.productTitle || document.title,
          text: root.dataset.productTitle || document.title,
          url: getShareUrl()
        }).catch(function (error) {
          if (error && error.name !== 'AbortError') setShareMenu(true);
        });
        return;
      }
      copyShareUrl();
    }

    if (mobileShareToggle) mobileShareToggle.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      openNativeShareOrMenu();
    });

    var mobileChatButton = document.querySelector('[data-nt-mobile-chat]');

    function openLiveChat(attempt) {
      if (typeof window.Chatra === 'function') {
        window.Chatra('openChat', true);
        return;
      }
      if (attempt < 10) {
        window.setTimeout(function () { openLiveChat(attempt + 1); }, 200);
      }
    }

    if (mobileChatButton) {
      mobileChatButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        document.documentElement.classList.add('nt-pdp-chat-open');
        document.querySelectorAll('.nt-pdp-chat-launcher-overlay').forEach(function (element) {
          element.classList.remove('nt-pdp-chat-launcher-overlay');
        });
        openLiveChat(0);
        window.setTimeout(function () {
          document.documentElement.classList.remove('nt-pdp-chat-open');
          window.dispatchEvent(new Event('resize'));
        }, 1800);
      });
    }

    initProductTabs(root);
    initProductReviewList(root);

  }

  function initFloatingUtilityOffsets() {
    if (!window.matchMedia('(max-width: 767px)').matches || !document.querySelector('[data-nt-product]')) return;

    if(window.NTProductUtilityOffsetsReady)return;window.NTProductUtilityOffsetsReady=true;
    var scanQueued = false;
    var chatMatcher = /chatra|chat-widget|chat-launcher/i;

    function scan() {
      scanQueued = false;
      document.querySelectorAll('.nt-pdp-chat-launcher-overlay').forEach(function (element) {
        element.classList.remove('nt-pdp-chat-launcher-overlay');
      });
      document.querySelectorAll('body > *, body > * > iframe').forEach(function (element) {
        if (element.closest('[data-nt-product], .nt-pdp__mobile-bar, .nt-header')) return;
        var style = window.getComputedStyle(element);
        if (style.position !== 'fixed' || style.display === 'none' || style.visibility === 'hidden') return;
        var rect = element.getBoundingClientRect();
        if (rect.width < 30 || rect.width > 240 || rect.height < 28 || rect.height > 110) return;
        if (rect.bottom < window.innerHeight - 150) return;
        var identity = [element.id, element.className, element.getAttribute('title'), element.getAttribute('aria-label'), element.textContent]
          .filter(Boolean).join(' ');
        if (!document.documentElement.classList.contains('nt-pdp-chat-open') && chatMatcher.test(identity)) {
          element.classList.add('nt-pdp-chat-launcher-overlay');
        }
      });
    }

    function queueScan() {
      if (scanQueued) return;
      scanQueued = true;
      window.requestAnimationFrame(scan);
    }

    queueScan();
    [400, 1200, 3000, 7000].forEach(function (delay) { window.setTimeout(queueScan, delay); });
    window.addEventListener('resize', queueScan, { passive: true });
    window.addEventListener('orientationchange', queueScan, { passive: true });

    var observer = new MutationObserver(queueScan);
    observer.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(function () { observer.disconnect(); }, 15000);
  }

  function boot(context) {
    var scope = context && context.querySelectorAll ? context : document;
    scope.querySelectorAll('[data-nt-product]').forEach(initProduct);
    if (scope.matches && scope.matches('[data-nt-product]')) initProduct(scope);
    if (document.querySelector('[data-nt-product]')) document.documentElement.classList.add('nt-pdp-has-product-page');
    initFloatingUtilityOffsets();
  }

  document.querySelectorAll('[data-nt-product]').forEach(applyProductFitment);
  document.addEventListener('nt:product:mount', function(event) { boot(event.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();


(function () {
  function initTrustCenter(root) {
    var modal = root.querySelector('[data-nt-trust-modal]');
    var openButton = root.querySelector('[data-nt-trust-open]');
    if (!modal || !openButton || modal.dataset.ntTrustReady === 'true') return;
    modal.dataset.ntTrustReady = 'true';

    var dialog = modal.querySelector('[role="dialog"]');
    var closeButtons = modal.querySelectorAll('[data-nt-trust-close]');
    var tabs = Array.prototype.slice.call(modal.querySelectorAll('[data-nt-trust-tab]'));
    var panels = Array.prototype.slice.call(modal.querySelectorAll('[data-nt-trust-panel]'));
    var previousFocus = null;

    function selectTab(name, focusTab) {
      tabs.forEach(function (tab) {
        var selected = tab.getAttribute('data-nt-trust-tab') === name;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.tabIndex = selected ? 0 : -1;
        if (selected && focusTab) tab.focus();
      });
      panels.forEach(function (panel) {
        var selected = panel.getAttribute('data-nt-trust-panel') === name;
        panel.hidden = !selected;
        panel.classList.toggle('is-active', selected);
      });
    }

    function openModal() {
      previousFocus = document.activeElement;
      modal.hidden = false;
      document.documentElement.classList.add('nt-pdp-trust-open');
      selectTab('payment', false);
      window.requestAnimationFrame(function () {
        modal.scrollTop = 0;
        if (dialog) dialog.focus();
      });
    }

    function closeModal() {
      modal.hidden = true;
      document.documentElement.classList.remove('nt-pdp-trust-open');
      if (previousFocus && previousFocus.focus) previousFocus.focus();
    }

    openButton.addEventListener('click', openModal);
    closeButtons.forEach(function (button) { button.addEventListener('click', closeModal); });

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () { selectTab(tab.getAttribute('data-nt-trust-tab'), false); });
      tab.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        var direction = event.key === 'ArrowRight' ? 1 : -1;
        var next = (index + direction + tabs.length) % tabs.length;
        selectTab(tabs[next].getAttribute('data-nt-trust-tab'), true);
      });
    });

    modal.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeModal();
      if (event.key !== 'Tab') return;
      var focusable = Array.prototype.slice.call(modal.querySelectorAll('button:not([disabled]), a[href]')).filter(function (item) {
        return !item.hidden && item.offsetParent !== null && item.tabIndex !== -1;
      });
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  function bootTrustCenters(context) {
    var scope = context && context.querySelectorAll ? context : document;
    scope.querySelectorAll('[data-nt-product]').forEach(initTrustCenter);
    if (scope.matches && scope.matches('[data-nt-product]')) initTrustCenter(scope);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { bootTrustCenters(); });
  else bootTrustCenters();

  document.addEventListener('shopify:section:load', function (event) {
    bootTrustCenters(event.target);
  });
})();

// Cabinet ETA is a warehouse-availability estimate, never an automatic arrival event.
(function(){
  function refreshPresaleDate(){
    var today=new Intl.DateTimeFormat('en-CA',{timeZone:'Asia/Shanghai',year:'numeric',month:'2-digit',day:'2-digit'}).format(new Date());
    document.querySelectorAll('[data-nt-presale-eta]').forEach(function(node){
      var eta=node.dataset.ntPresaleEta;
      var label=node.querySelector('[data-nt-presale-date]');
      if(label)label.textContent=/^\d{4}-\d{2}-\d{2}$/.test(eta)&&eta>=today?eta:'Updated date pending.';
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',refreshPresaleDate);else refreshPresaleDate();
  setInterval(refreshPresaleDate,60000);
})();

/* Desktop-only composition, restored on mobile without changing purchase handlers. */
(function(){
  function boot(target){
    var root=target&&target.matches&&target.matches('[data-nt-product]')?target:document.querySelector('[data-nt-product]');
    if(!root || root.dataset.ntPcLayout)return;
    root.dataset.ntPcLayout='2';
    var mq=matchMedia('(min-width:1024px)'),undo=[];
    function move(node,parent,before){if(!node||!parent)return;var mark=document.createComment('PC restore');node.before(mark);parent.insertBefore(node,before||null);undo.push(function(){mark.replaceWith(node);});}
    function add(node,parent,before){parent.insertBefore(node,before||null);undo.push(function(){node.remove();});return node;}
    function listen(node,type,fn){node.addEventListener(type,fn);undo.push(function(){node.removeEventListener(type,fn);});}
    function render(){
      undo.reverse().forEach(function(fn){fn();});undo=[];
      // Shared display hierarchy for ABS kits; original product records remain intact.
      var h1=root.querySelector('h1'),title=root.dataset.productTitle||'';
      var brand=root.dataset.vehicleBrand,models=root.dataset.vehicleModels;
      var years=(root.dataset.modelYears||'').split(',').map(function(v){return v.trim();}).filter(Boolean);
      var style=title.match(/\b(N\d+)\s*-\s*([^|]+)\|\s*(ABS\s+Injection)\b/i);
      if(h1&&root.dataset.fitmentStatus==='complete'&&root.dataset.fitmentModelYears&&style){
        var original=Array.from(h1.childNodes);
        var badges=Array.from(h1.querySelectorAll('.nt-us-stock-label,.nt-presale-label'));
        var modelText=models.split('||').map(function(model){return model.trim().replace(/GSX[ -]?R\s*(\d+)/ig,'GSX-R$1');}).join(' / ');
        var heading='Fairing Kit Fit for '+root.dataset.fitmentBrand+' '+root.dataset.fitmentModelYears;
        h1.replaceChildren(document.createTextNode(heading));
        badges.forEach(function(badge){h1.insertBefore(badge.cloneNode(true),h1.firstChild);});
        undo.push(function(){h1.replaceChildren.apply(h1,original);});
        var color=style[2].trim().replace(/,?\s*US Stock\s*$/i,'');
        color=color.replace(/^(Blue|White|Black|Red|Yellow|Green|Orange|Purple|Silver|Gray|Gold)\s+(Blue|White|Black|Red|Yellow|Green|Orange|Purple|Silver|Gray|Gold)$/i,'$1 & $2');
        var sub=document.createElement('p');sub.className='nt-pc-title-subline';
        sub.textContent=color+' · Injection-Molded ABS · '+style[1].toUpperCase();
        add(sub,h1.parentNode);
      }
      if(!mq.matches)return;
      // Keep long product titles readable; stock badges retain their own row.
      if(h1){
        var titleBadges=Array.from(h1.querySelectorAll('.nt-us-stock-label,.nt-presale-label'));
        if(titleBadges.length){var badgeRow=document.createElement('div');badgeRow.className='nt-pc-title-badges';add(badgeRow,h1.parentNode,h1);titleBadges.forEach(function(b){move(b,badgeRow);});}
        h1.classList.add('nt-pc-title-readable');
        undo.push(function(){h1.classList.remove('nt-pc-title-readable');});
      }

      var details=root.querySelector('.nt-pdp__details'),media=root.querySelector('.nt-pdp__media'),purchase=root.querySelector('.nt-pdp__purchase-actions'),template=root.querySelector('[data-nt-pc-content]');
      move(root.querySelector('.nt-pdp__product-actions'),media);

      if(!root.querySelector('.nt-pdp__rating')){
        var review=document.createElement('a');review.className='nt-pc-review';review.href='#reviews';review.textContent='Read customer reviews';
        review.addEventListener('click',function(e){e.preventDefault();var tab=root.querySelector('[data-nt-product-tab="reviews"]');if(tab){tab.click();}});add(review,details);
      }
      var stock=root.querySelector('.nt-pdp__stock:not(.nt-pdp__stock--preorder)'),price=root.querySelector('.nt-pdp__price');
      if(stock&&price){
        var status=document.createElement('span');status.className='nt-pc-stock';var dot=document.createElement('i');dot.className='fa fa-circle';dot.setAttribute('aria-hidden','true');status.append(dot,document.createTextNode(stock.textContent.replace('✓','').trim()));add(status,price);
        var availability=stock.closest('[data-nt-availability-details]');
        function sync(){status.hidden=!!(availability&&availability.hidden);}
        sync();var watch=new MutationObserver(sync);if(availability)watch.observe(availability,{attributes:true,attributeFilter:['hidden']});undo.push(function(){watch.disconnect();});
      }
      if(template){
        var colors=template.content.querySelector('.nt-pc-colors');if(colors)add(colors.cloneNode(true),details);
        var gifts=root.querySelector('.nt-kit-gifts'),giftVisual=template.content.querySelector('[data-pc-gifts]');
        if(gifts&&giftVisual){gifts.classList.add('nt-pc-gifts-active');undo.push(function(){gifts.classList.remove('nt-pc-gifts-active');});add(giftVisual.cloneNode(true),gifts);}
      }
      var eta=root.querySelector('.nt-kit-eta');
      if(eta){
        var truck=document.createElement('i');truck.className='fa fa-truck nt-pc-truck';truck.setAttribute('aria-hidden','true');add(truck,eta);
        var select=eta.querySelector('select'),label=eta.querySelector('label');
        if(select&&label){
          var wasHidden=select.hidden;select.hidden=true;undo.push(function(){select.hidden=wasHidden;});
          var destination=document.createElement('span');destination.className='nt-pc-destination';
          var change=document.createElement('button');change.type='button';change.className='nt-pc-change';change.textContent='Change';change.setAttribute('aria-expanded','false');
          add(destination,label,select);add(change,label,select);
          function syncDestination(){destination.textContent=select.value==='mainland'?'United States':select.options[select.selectedIndex].text;select.hidden=true;change.setAttribute('aria-expanded','false');}
          syncDestination();listen(select,'change',syncDestination);change.addEventListener('click',function(){select.hidden=!select.hidden;change.setAttribute('aria-expanded',String(!select.hidden));if(!select.hidden)select.focus();});
        }
      }
      if(purchase){
        var qty=document.createElement('div');qty.className='nt-pc-quantity';qty.innerHTML='<button type="button" aria-label="Decrease quantity"><i class="fa fa-minus" aria-hidden="true"></i></button><input type="number" name="quantity" min="1" max="99" value="1" aria-label="Quantity"><button type="button" aria-label="Increase quantity"><i class="fa fa-plus" aria-hidden="true"></i></button>';
        var input=qty.querySelector('input');qty.querySelectorAll('button').forEach(function(button,i){button.addEventListener('click',function(){input.value=Math.max(1,Math.min(99,(parseInt(input.value,10)||1)+(i?1:-1)));});});input.addEventListener('change',function(){input.value=Math.max(1,Math.min(99,parseInt(input.value,10)||1));});add(qty,purchase,purchase.firstChild);
      }
      var returns=root.querySelector('.nt-pdp__desktop-returns'),payments=root.querySelector('.nt-pdp__mobile-installments');
      var services=document.createElement('div');services.className='nt-pc-services';services.innerHTML='<button type="button" data-pc-return aria-expanded="false"><i class="fa fa-shield" aria-hidden="true"></i><span>30-day free returns</span></button><button type="button" data-pc-payment aria-expanded="false"><i class="fa fa-lock" aria-hidden="true"></i><span>Secure payment</span></button><a href="/pages/contact-us#support-contact"><i class="fa fa-headphones" aria-hidden="true"></i><span>Quality support</span></a>';add(services,details);
      if(returns){var oldOpen=returns.open;undo.push(function(){returns.open=oldOpen;});services.querySelector('[data-pc-return]').addEventListener('click',function(){returns.open=!returns.open;this.setAttribute('aria-expanded',String(returns.open));});}
      if(payments){undo.push(function(){payments.classList.remove('nt-pc-payment-open');});services.querySelector('[data-pc-payment]').addEventListener('click',function(){var open=payments.classList.toggle('nt-pc-payment-open');this.setAttribute('aria-expanded',String(open));});}
      var guarantee=root.querySelector('.nt-stock-guarantee');
      if(guarantee){var fold=document.createElement('details');fold.className='nt-pc-guarantee';var summary=document.createElement('summary');summary.textContent='US stock guarantee · View details';fold.append(summary);add(fold,details);move(guarantee,fold);}
      // Preserve the original form and handlers; moved controls explicitly retain form ownership.
      var scroll=document.createElement('div');scroll.className='nt-pc-info-scroll';
      var children=Array.from(details.children);add(scroll,details);
      children.forEach(function(node){move(node,scroll);});
      var dock=document.createElement('div');dock.className='nt-pc-buy-dock';add(dock,details);
      if(purchase){
        var form=purchase.closest('form');
        if(form){purchase.querySelectorAll('button,input,select').forEach(function(control){var prior=control.getAttribute('form');control.setAttribute('form',form.getAttribute('id'));undo.push(function(){if(prior===null)control.removeAttribute('form');else control.setAttribute('form',prior);});});}
        move(purchase,dock);
      }
      // PC trust placement 20260916
      move(services,dock,purchase);
      var paymentTemplate=root.querySelector('[data-nt-pc-payment-template]');var icons=paymentTemplate?paymentTemplate.content.querySelector('.nt-pdp__payment-icons'):root.querySelector('.nt-pdp__payment-icons');
      if(icons){var paymentStrip=icons.cloneNode(true);paymentStrip.classList.add('nt-pc-payment-strip');add(paymentStrip,dock);}
      if(guarantee&&fold&&price){
        fold.classList.add('nt-pc-guarantee-source');
        var modal=document.createElement('dialog');modal.className='nt-pc-stock-dialog';modal.setAttribute('aria-label','US stock guarantee');
        var close=document.createElement('button');close.type='button';close.className='nt-pc-dialog-close';close.setAttribute('aria-label','Close stock guarantee');close.textContent='×';modal.appendChild(close);var modalTitle=document.createElement('h2');modalTitle.className='nt-pc-guarantee-title';modalTitle.textContent='US STOCK GUARANTEE';modal.appendChild(modalTitle);
        var modalBody=guarantee.cloneNode(true);modalBody.removeAttribute('id');modalBody.querySelectorAll('[id]').forEach(function(n){n.removeAttribute('id');});modal.appendChild(modalBody);add(modal,document.body);
        var trigger=root.querySelector('.nt-pc-stock');
        if(trigger){trigger.replaceChildren(document.createTextNode('US stock guarantee'));trigger.setAttribute('role','button');trigger.setAttribute('tabindex','0');trigger.setAttribute('aria-haspopup','dialog');
          function openGuarantee(){modal.showModal();}
          listen(trigger,'click',openGuarantee);listen(trigger,'keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();openGuarantee();}});
        }
        close.addEventListener('click',function(){modal.close();});
        modal.addEventListener('click',function(e){if(e.target===modal){var r=modal.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)modal.close();}});
        undo.push(function(){if(modal.open)modal.close();fold.classList.remove('nt-pc-guarantee-source');});
      }
      var guide=root.querySelector('[data-nt-fitment-guide]'),fitment=root.querySelector('[data-nt-fitment]');
      if(false&&guide&&fitment){
        var heading=fitment.querySelector('legend,h2,h3,strong');
        if(heading){
          var originalGuideOpen=guide.open;undo.push(function(){guide.open=originalGuideOpen;guide.classList.remove('nt-pc-context-fitment');});
          guide.classList.add('nt-pc-context-fitment');move(guide,fitment);
          var expand=document.createElement('button');expand.type='button';expand.className='nt-pc-fitment-expand';expand.textContent='⌄';expand.setAttribute('aria-label','Expand fitment notes and installation');expand.setAttribute('aria-expanded',String(guide.open));add(expand,heading);
          listen(expand,'click',function(){guide.open=!guide.open;expand.setAttribute('aria-expanded',String(guide.open));expand.textContent=guide.open?'⌃':'⌄';});
        }
      }

      // PC polish seven items 20260916
      var titleRow=root.querySelector('.nt-pdp__title-row'),metaRow=root.querySelector('.nt-pc-title-meta'),subline=root.querySelector('.nt-pc-title-subline');
      if(metaRow&&h1){
        var titleBadge=metaRow.querySelector('.nt-us-stock-label,.nt-presale-label');
        if(titleBadge)move(titleBadge,h1,h1.firstChild);
        var design=metaRow.querySelector('span');
        if(design&&subline){var designCopy=document.createElement('span');designCopy.className='nt-pc-design-code';designCopy.textContent=' · '+design.textContent;add(designCopy,subline);}
      }
      var originalServices=Array.from(services.childNodes);
      var serviceLabels=['30-day free returns','Secure payment','Quality support'];
      var serviceIcons=['fa-shield','fa-lock','fa-headphones'];
      services.replaceChildren();serviceLabels.forEach(function(label,i){var item=document.createElement('span');item.className='nt-pc-assurance-icon';item.setAttribute('role','img');item.setAttribute('aria-label',label);item.title=label;var icon=document.createElement('i');icon.className='fa '+serviceIcons[i];icon.setAttribute('aria-hidden','true');item.removeAttribute('role');item.appendChild(icon);var caption=document.createElement('span');caption.textContent=label;item.appendChild(caption);services.appendChild(item);});
      undo.push(function(){services.replaceChildren.apply(services,originalServices);});
      var etaNote=root.querySelector('[data-eta-note]');
      if(etaNote){var oldWhiteSpace=etaNote.style.whiteSpace;etaNote.style.whiteSpace='pre-line';
        function formatEtaNote(){var text=etaNote.textContent;var formatted=text;var days=text.match(/\d+\s*[–-]\s*\d+\s+business days/i);if(days&&/Ships within 1 business day/i.test(text)){formatted='Ships within 1 business day · Estimated delivery: '+days[0]+'.\nWeekends and holidays may extend delivery.';}if(formatted!==text)etaNote.textContent=formatted;}
        formatEtaNote();var etaWatcher=new MutationObserver(formatEtaNote);etaWatcher.observe(etaNote,{childList:true,characterData:true,subtree:true});undo.push(function(){etaWatcher.disconnect();etaNote.textContent=etaNote.textContent.replace(/\n/g,' ');etaNote.style.whiteSpace=oldWhiteSpace;});
      }
      // Desktop ETA disclosure 20260916.
      var etaResult=root.querySelector('[data-eta-result]');
      if(eta&&etaNote&&etaResult){
        var etaPinned=false,etaHovered=false,etaFocused=false;
        var previousAttrs={};['role','tabindex','aria-expanded'].forEach(function(k){previousAttrs[k]=etaResult.getAttribute(k);});
        eta.classList.add('nt-pc-eta-disclosure');etaResult.setAttribute('role','button');etaResult.setAttribute('tabindex','0');
        function syncEtaDisclosure(){var open=etaPinned||etaHovered||etaFocused;eta.classList.toggle('nt-pc-eta-open',open);etaResult.setAttribute('aria-expanded',String(open));}
        listen(etaResult,'mouseenter',function(){etaHovered=true;syncEtaDisclosure();});
        listen(eta,'mouseleave',function(){etaHovered=false;syncEtaDisclosure();});
        listen(etaResult,'focus',function(){etaFocused=true;syncEtaDisclosure();});
        listen(etaResult,'blur',function(){etaFocused=false;syncEtaDisclosure();});
        listen(etaResult,'click',function(){etaPinned=!etaPinned;etaFocused=false;etaHovered=false;syncEtaDisclosure();});
        listen(etaResult,'keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();etaPinned=!etaPinned;etaFocused=false;syncEtaDisclosure();}if(e.key==='Escape'){etaPinned=etaFocused=etaHovered=false;syncEtaDisclosure();}});
        syncEtaDisclosure();undo.push(function(){eta.classList.remove('nt-pc-eta-disclosure','nt-pc-eta-open');Object.keys(previousAttrs).forEach(function(k){if(previousAttrs[k]===null)etaResult.removeAttribute(k);else etaResult.setAttribute(k,previousAttrs[k]);});});
      }
      // Match non-US delivery presentation without changing fulfillment estimates.
      var otherDelivery=root.querySelector('.nt-pdp__delivery[aria-labelledby="nt-delivery-title"]:not(.nt-pdp__delivery--us)');
      if(otherDelivery){
        var deliverySource=otherDelivery;
        var deliveryGroup=document.createElement('div');deliveryGroup.className='nt-pdp__delivery nt-pc-shipping-eta';
        add(deliveryGroup,scroll);
        move(deliverySource.querySelector('h2'),deliveryGroup);
        move(deliverySource.querySelector(':scope > span'),deliveryGroup);
        otherDelivery=deliveryGroup;
        var deliveryHeading=otherDelivery.querySelector('h2'),deliveryNote=otherDelivery.querySelector(':scope > span');
        if(deliveryHeading&&deliveryNote){
          otherDelivery.classList.add('nt-pc-delivery-unified');
          var truckOther=document.createElement('i');truckOther.className='fa fa-truck nt-pc-truck';truckOther.setAttribute('aria-hidden','true');add(truckOther,otherDelivery);
          var deliveryAttrs={};['role','tabindex','aria-expanded'].forEach(function(k){deliveryAttrs[k]=deliveryHeading.getAttribute(k);});
          deliveryHeading.setAttribute('role','button');deliveryHeading.setAttribute('tabindex','0');
          var deliveryPinned=false,deliveryHovered=false,deliveryFocused=false;
          function syncOtherDelivery(){var open=deliveryPinned||deliveryHovered||deliveryFocused;otherDelivery.classList.toggle('nt-pc-delivery-open',open);deliveryHeading.setAttribute('aria-expanded',String(open));}
          listen(deliveryHeading,'mouseenter',function(){deliveryHovered=true;syncOtherDelivery();});
          listen(otherDelivery,'mouseleave',function(){deliveryHovered=false;syncOtherDelivery();});
          listen(deliveryHeading,'focus',function(){deliveryFocused=true;syncOtherDelivery();});
          listen(deliveryHeading,'blur',function(){deliveryFocused=false;syncOtherDelivery();});
          listen(deliveryHeading,'click',function(){deliveryPinned=!deliveryPinned;deliveryFocused=deliveryHovered=false;syncOtherDelivery();});
          listen(deliveryHeading,'keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();deliveryPinned=!deliveryPinned;deliveryFocused=deliveryHovered=false;syncOtherDelivery();}if(e.key==='Escape'){deliveryPinned=deliveryFocused=deliveryHovered=false;syncOtherDelivery();}});
          syncOtherDelivery();undo.push(function(){otherDelivery.classList.remove('nt-pc-delivery-unified','nt-pc-delivery-open');Object.keys(deliveryAttrs).forEach(function(k){if(deliveryAttrs[k]===null)deliveryHeading.removeAttribute(k);else deliveryHeading.setAttribute(k,deliveryAttrs[k]);});});
        }
      }
      // Shipping display follows confirmed fulfillment/region rates, not checkout configuration.
      var shipping=document.createElement('div');shipping.className='nt-pc-shipping-rate';
      var shippingAmount=document.createElement('strong');var shippingSelect=document.createElement('select');shippingSelect.hidden=true;shippingSelect.tabIndex=-1;shippingSelect.setAttribute('aria-hidden','true');
      [['mainland','Contiguous US'],['remote','Alaska / Hawaii / Puerto Rico'],['mexico','Mexico'],['other','Other destinations']].forEach(function(pair){var option=document.createElement('option');option.value=pair[0];option.textContent=pair[1];shippingSelect.appendChild(option);});
      var country=(root.dataset.shippingCountryCode||'').toUpperCase(),province=(root.dataset.shippingProvince||'').toUpperCase();
      var remoteUS=country==='PR'||(country==='US'&&(province==='AK'||province==='HI'||province==='PR'));
      shippingSelect.value=remoteUS?'remote':country==='US'?'mainland':country==='MX'?'mexico':'other';
      shipping.append(shippingAmount,shippingSelect);add(shipping,scroll);
      var existingDestination=root.querySelector('.nt-kit-eta select');
      var originalOtherHeading=deliveryHeading?deliveryHeading.textContent:null;
      var originalOtherNote=deliveryNote?deliveryNote.textContent:null;
      function refreshRegionalEta(){
        if(root.dataset.fulfillment==='china')return;
        var region=shippingSelect.value,days=region==='remote'?'7–14':region==='mexico'?'10–15':null;
        if(region==='other'){
          var chinaHeading=etaResult||deliveryHeading,chinaNote=etaNote||deliveryNote;
          var chinaCopy='Estimated delivery: about 5–6 weeks · Ships from China';
          var chinaDetail='Made to order and shipped from China · Estimated delivery: about 5–6 weeks.\nWeekends and holidays may extend delivery.';
          if(chinaHeading&&chinaHeading.textContent!==chinaCopy)chinaHeading.textContent=chinaCopy;
          if(chinaNote&&chinaNote.textContent!==chinaDetail)chinaNote.textContent=chinaDetail;
        }else if(days){
          var heading=etaResult||deliveryHeading,note=etaNote||deliveryNote;
          var presale=!etaResult;
          var copy='Estimated delivery: '+days+' business days'+(presale?' after arrival at our US warehouse':'');
          var detail=(presale?'Ships within 1 business day after arrival at our US warehouse':'Ships within 1 business day')+' · Estimated delivery: '+days+' business days.\nWeekends and holidays may extend delivery.';
          if(heading&&heading.textContent!==copy)heading.textContent=copy;
          if(note&&note.textContent!==detail)note.textContent=detail;
        }else if(deliveryHeading&&originalOtherHeading!==null){
          deliveryHeading.textContent=originalOtherHeading;
          if(deliveryNote)deliveryNote.textContent=originalOtherNote;
        }
      }
      if(etaResult){var regionalEtaWatcher=new MutationObserver(refreshRegionalEta);regionalEtaWatcher.observe(etaResult,{childList:true,subtree:true,characterData:true});undo.push(function(){regionalEtaWatcher.disconnect();});}
      function refreshShipping(){
        var domestic=root.dataset.fulfillment==='china';var region=shippingSelect.value;
        shippingAmount.textContent=region==='mainland'?'Free shipping':region==='other'?'+ $100 USD shipping':region==='mexico'?'+ $200 USD shipping':region==='remote'?'+ $400 USD shipping':'Shipping calculated at checkout';
        shippingAmount.classList.toggle('is-free',region==='mainland');
        refreshRegionalEta();
      }
      listen(shippingSelect,'change',function(){refreshShipping();if(existingDestination){existingDestination.value=shippingSelect.value==='mainland'?'mainland':'other';existingDestination.dispatchEvent(new Event('change',{bubbles:true}));}});
      if(existingDestination)listen(existingDestination,'change',function(){if(existingDestination.value==='mainland')shippingSelect.value='mainland';else if(shippingSelect.value==='mainland')shippingSelect.value='other';refreshShipping();});
      refreshShipping();
      if(eta){
        move(eta,scroll,shipping.nextSibling);eta.classList.add('nt-pc-shipping-eta');
        undo.push(function(){eta.classList.remove('nt-pc-shipping-eta');});
      }
      if(existingDestination){existingDestination.value=shippingSelect.value==='mainland'?'mainland':'other';existingDestination.dispatchEvent(new Event('change',{bubbles:true}));}
      var benefits=document.createElement('div');benefits.className='nt-pc-benefits-row';benefits.setAttribute('aria-label','Shipping and purchase benefits');
      add(benefits,purchase?purchase.parentNode:scroll,purchase||null);
      var stockBenefit=root.querySelector('.nt-pc-stock[role="button"]');
      if(stockBenefit){
        move(stockBenefit,benefits);
        var stockIcon=document.createElement('span');stockIcon.className='nt-pc-benefit-icon';stockIcon.setAttribute('aria-hidden','true');stockIcon.innerHTML='<svg viewBox="0 0 24 24"><path d="m4 6 8-3 8 3v12l-8 3-8-3V6Zm0 0 8 3 8-3M12 9v12M8 4.5l8 3"/></svg>';
        stockBenefit.replaceChildren(stockIcon,document.createTextNode('US stock guarantee'));
      }

      if(!stockBenefit){
        var fulfillmentBenefit=document.createElement('div');fulfillmentBenefit.className='nt-pc-fulfillment-benefit';
        fulfillmentBenefit.innerHTML='<span class="nt-pc-benefit-icon" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="m4 6 8-3 8 3v12l-8 3-8-3V6Zm0 0 8 3 8-3M12 9v12M8 4.5l8 3"/></svg></span>';
        var fulfillmentText=document.createElement('strong');fulfillmentText.textContent=root.dataset.fulfillment==='preorder'?'Arriving US Soon':'Made to order';
        fulfillmentBenefit.appendChild(fulfillmentText);add(fulfillmentBenefit,benefits);
      }
      move(shipping,benefits);
      var shippingIcon=document.createElement('span');shippingIcon.className='nt-pc-benefits-truck';shippingIcon.setAttribute('aria-hidden','true');shippingIcon.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M3 5h11v12H3zM14 9h4l3 4v4h-7"/><circle cx="7" cy="18" r="2"/><circle cx="18" cy="18" r="2"/></svg>';shipping.prepend(shippingIcon);
      undo.push(function(){shippingIcon.remove();});
      // Compact return explanation in the space beneath the form note.
      var returnSource=root.querySelector('.nt-pdp__desktop-return-details'),returnLabel=root.querySelector('.nt-pdp__desktop-return-label'),formNote=root.querySelector('[data-nt-fitment-note]');
      if(returnSource&&formNote){
        var returnCard=document.createElement('div');returnCard.className='nt-pc-return-card';
        var returnIcon=document.createElement('span');returnIcon.className='nt-pc-return-icon';returnIcon.setAttribute('aria-hidden','true');returnIcon.innerHTML='<svg viewBox="0 0 24 24" focusable="false"><path d="M12 3 4.5 6v5.5c0 4.4 2.9 7.5 7.5 9.5 4.6-2 7.5-5.1 7.5-9.5V6L12 3Z"/><path d="m8 11.5 2.7 2.7 5.3-5.3"/></svg>';
        var returnText=document.createElement('span');returnText.className='nt-pc-return-text';
        var returnHeading=document.createElement('strong');returnHeading.textContent='30-day free returns';
        var returnCopy=document.createElement('span');returnCopy.className='nt-pc-return-terms';returnCopy.textContent=returnLabel?returnLabel.textContent.trim():'See eligibility and return details.';
        var returnReasons=document.createElement('span');returnReasons.className='nt-pc-return-reasons';returnReasons.textContent=/custom-order/i.test(returnCopy.textContent)?'Damaged / incorrect order · Not as approved':'Wrong model · Fitment issue · Damaged / incorrect order';returnText.append(returnHeading);
        var returnButton=document.createElement('button');returnButton.type='button';returnButton.textContent='View details ›';returnButton.setAttribute('aria-haspopup','dialog');returnButton.setAttribute('aria-label','View 30-day free return details');returnCard.append(returnIcon,returnText,returnButton);
        add(returnCard,benefits);
        var returnDialog=document.createElement('dialog');returnDialog.className='nt-pc-return-dialog';returnDialog.setAttribute('aria-label','30-day free returns');
        var returnClose=document.createElement('button');returnClose.type='button';returnClose.className='nt-pc-return-close';returnClose.setAttribute('aria-label','Close return details');returnClose.textContent='×';
        var returnHeader=document.createElement('header');returnHeader.className='nt-pc-return-dialog__header';
        var returnHeaderCopy=document.createElement('span'),returnKicker=document.createElement('small'),returnTitle=document.createElement('h2');returnKicker.textContent='30-DAY FREE RETURNS';returnTitle.textContent='RETURN WITH CONFIDENCE';returnHeaderCopy.append(returnKicker,returnTitle);
        var returnMetric=document.createElement('span');returnMetric.className='nt-pc-return-dialog__metric';var returnMetricValue=document.createElement('strong'),returnMetricLabel=document.createElement('small');returnMetricValue.textContent='30 DAYS';returnMetricLabel.textContent='PREPAID LABEL · NO RESTOCKING FEE';returnMetric.append(returnMetricValue,returnMetricLabel);returnHeader.append(returnHeaderCopy,returnMetric);
        var returnBody=returnSource.cloneNode(true);returnBody.removeAttribute('id');returnBody.querySelectorAll('[id]').forEach(function(n){n.removeAttribute('id');});
        var returnIntro=returnBody.querySelector('p:not(.nt-pdp__desktop-return-care)');if(returnIntro)returnIntro.classList.add('nt-pc-return-intro');
        var returnStepNames=['START YOUR RETURN','OUR RESPONSE','APPROVAL & LABEL'];returnBody.querySelectorAll('ol>li').forEach(function(item,index){var itemCopy=document.createElement('span');while(item.firstChild)itemCopy.appendChild(item.firstChild);var itemTitle=document.createElement('strong');itemTitle.textContent=returnStepNames[index]||('STEP '+(index+1));var itemBody=document.createElement('span');while(itemCopy.firstChild)itemBody.appendChild(itemCopy.firstChild);var itemText=document.createElement('span');itemText.className='nt-pc-return-step-copy';itemText.append(itemTitle,itemBody);item.append(itemText);});
        var returnSummary=document.createElement('p');returnSummary.className='nt-pc-return-summary';returnSummary.textContent=returnReasons.textContent+' · '+returnCopy.textContent;returnBody.prepend(returnSummary);
        returnDialog.append(returnClose,returnHeader,returnBody);add(returnDialog,document.body);
        listen(returnButton,'click',function(){returnDialog.showModal();});listen(returnClose,'click',function(){returnDialog.close();});
        listen(returnDialog,'click',function(e){if(e.target===returnDialog){var r=returnDialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)returnDialog.close();}});
        undo.push(function(){if(returnDialog.open)returnDialog.close();});
      }
      // Desktop fitment guidance: preserve SKU-specific fitment values.
      var fitmentTable=root.querySelector('.nt-pdp__fitment-summary');
      if(fitmentTable){
        var fitmentPanel=fitmentTable.closest('[data-nt-fitment]'),fitmentLegend=fitmentPanel&&fitmentPanel.querySelector('legend,h2,h3,strong');
        if(fitmentLegend){var originalFitmentLegend=fitmentLegend.textContent;fitmentLegend.textContent=root.dataset.fitmentLabel||originalFitmentLegend;undo.push(function(){fitmentLegend.textContent=originalFitmentLegend;});}
        var fitmentHelp=document.createElement('div');fitmentHelp.className='nt-pc-fitment-help';
        var helpLink=document.createElement('a');helpLink.href='/pages/contact-us#support-contact';helpLink.textContent='Not sure? Ask us to check your bike →';
        var fitmentChatTimer=null;
        listen(helpLink,'click',function(event){
          if(event.ctrlKey||event.metaKey||event.shiftKey||event.altKey)return;
          event.preventDefault();
          if(fitmentChatTimer)return;
          var attempts=0,requested=false;
          function checkFitmentChat(){
            if(!mq.matches){fitmentChatTimer=null;return;}
            if(!requested && typeof window.Chatra==='function'){
              requested=true;
              var headerChat=document.querySelector('[data-nt-header-chat]');
              if(headerChat)headerChat.click();
              else{document.documentElement.classList.add('nt-chat-requested');window.Chatra('show');window.Chatra('openChat',true);}
            }
            var widget=document.getElementById('chatra');
            if(widget && widget.classList.contains('chatra--expanded')){fitmentChatTimer=null;return;}
            if(++attempts>=24){fitmentChatTimer=null;window.location.assign(helpLink.href);return;}
            fitmentChatTimer=window.setTimeout(checkFitmentChat,250);
          }
          checkFitmentChat();
        });
        undo.push(function(){window.clearTimeout(fitmentChatTimer);});
        fitmentHelp.append(helpLink);
        add(fitmentHelp,fitmentTable.parentNode,fitmentTable.nextSibling);
      }
      // Native document scrolling: only the gallery sticks, never the information column.
      // Keep the original purchase form and tabs in normal flow. No wheel interception.
      scroll.setAttribute('aria-label','Product information');
      var header=document.querySelector('[data-nt-header]');
      function sizeNativeGallery(){
        var top=Math.ceil(header?header.getBoundingClientRect().height:86)+12;
        var preview=document.getElementById('PBarNextFrame');
        var reserve=preview?64:0;
        var square=Math.max(180,media.getBoundingClientRect().width-80);
        root.style.setProperty('--nt-pc-sticky-top',top+'px');
        root.style.setProperty('--nt-pc-panel-height',square+'px');
      }
      sizeNativeGallery();listen(window,'resize',sizeNativeGallery);
      // Independent bottom purchase bar. Reference: hidden at 144px, visible at 162px.
      if(purchase&&h1){
        var bar=document.createElement('aside');bar.className='nt-pc-sticky-purchase';bar.setAttribute('aria-label','Quick purchase');bar.hidden=true;
        var inner=document.createElement('div');inner.className='nt-pc-sticky-purchase__inner';bar.append(inner);
        var productInfo=document.createElement('div');productInfo.className='nt-pc-sticky-purchase__product';
        var hero=media.querySelector('.nt-pdp__main-image img');
        if(hero){var thumb=document.createElement('img');thumb.src=hero.currentSrc||hero.src;thumb.alt='';productInfo.append(thumb);}
        var productCopy=document.createElement('div'),barTitle=document.createElement('strong');barTitle.textContent=h1.textContent;productCopy.append(barTitle);
        var sub=root.querySelector('.nt-pc-title-subline');if(sub){var barSub=document.createElement('small');barSub.textContent=sub.textContent;productCopy.append(barSub);}
        productInfo.append(productCopy);inner.append(productInfo);
        var barPrice=document.createElement('strong');barPrice.className='nt-pc-sticky-purchase__price';inner.append(barPrice);
        var nativeQty=purchase.querySelector('input[name="quantity"]');
        var barQty=document.createElement('div');barQty.className='nt-pc-sticky-purchase__quantity';
        var minus=document.createElement('button'),amount=document.createElement('input'),plus=document.createElement('button');
        minus.type=plus.type='button';minus.textContent='−';plus.textContent='+';minus.setAttribute('aria-label','Decrease quick purchase quantity');plus.setAttribute('aria-label','Increase quick purchase quantity');
        amount.type='number';amount.min='1';amount.max='99';amount.value=nativeQty?nativeQty.value:'1';amount.setAttribute('aria-label','Quick purchase quantity');
        barQty.append(minus,amount,plus);inner.append(barQty);
        function setQuantity(value){amount.value=String(Math.max(1,Math.min(99,parseInt(value,10)||1)));if(nativeQty){nativeQty.value=amount.value;nativeQty.dispatchEvent(new Event('change',{bubbles:true}));}}
        listen(minus,'click',function(){setQuantity(Number(amount.value)-1);});listen(plus,'click',function(){setQuantity(Number(amount.value)+1);});listen(amount,'change',function(){setQuantity(amount.value);});
        if(nativeQty){listen(nativeQty,'input',function(){amount.value=nativeQty.value;});listen(nativeQty,'change',function(){amount.value=nativeQty.value;});listen(purchase,'click',function(){amount.value=nativeQty.value;});}
        var proxies=[];
        ['[data-nt-add-to-cart]','[data-nt-buy-now]'].forEach(function(selector,index){var original=purchase.querySelector(selector);if(!original)return;var button=document.createElement('button');button.type='button';button.className=index?'nt-pc-sticky-purchase__buy':'nt-pc-sticky-purchase__add';inner.append(button);proxies.push([button,original]);listen(button,'click',function(){setQuantity(amount.value);original.click();});});
        function syncPurchaseBar(){var priceNode=price&&price.querySelector('strong');barPrice.textContent=priceNode?priceNode.textContent.replace(/\s*USD\b/g,''):'';proxies.forEach(function(pair){pair[0].textContent=pair[1].textContent.trim();pair[0].disabled=pair[1].disabled;});}
        add(bar,document.body);syncPurchaseBar();
        var syncObserver=new MutationObserver(syncPurchaseBar);if(price)syncObserver.observe(price,{childList:true,subtree:true,characterData:true});syncObserver.observe(purchase,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['disabled']});
        function updatePurchaseBar(){bar.hidden=window.scrollY<=150;var preview=document.getElementById('PBarNextFrame');bar.style.bottom=preview?'64px':'0px';}
        listen(window,'scroll',updatePurchaseBar);listen(window,'resize',updatePurchaseBar);updatePurchaseBar();
        var endSpace=document.createElement('div');endSpace.className='nt-pc-sticky-purchase-space';endSpace.setAttribute('aria-hidden','true');add(endSpace,document.body);
        undo.push(function(){syncObserver.disconnect();});
      }

      var galleryObserver=new ResizeObserver(sizeNativeGallery);if(header)galleryObserver.observe(header);
      undo.push(function(){galleryObserver.disconnect();root.style.removeProperty('--nt-pc-sticky-top');root.style.removeProperty('--nt-pc-panel-height');});


    }
    root.addEventListener('nt:fitment:resolved',render);mq.addEventListener('change',render);
    root.addEventListener('nt:product:unload',function(){mq.removeEventListener('change',render);root.removeEventListener('nt:fitment:resolved',render);undo.reverse().forEach(function(fn){fn();});undo=[];},{once:true});
    render();
  }
  window.NTProductLayout=boot;
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();

// Shared fulfillment presentation. Existing source estimates remain authoritative.
(function(){
 function init(){document.querySelectorAll('[data-nt-product]').forEach(function(root){
  if(root.querySelector('.nt-shared-delivery'))return;
  var card=document.createElement('section');card.className='nt-shared-delivery';card.setAttribute('aria-label','Estimated delivery');
  card.innerHTML='<i class="fa fa-truck" aria-hidden="true"></i><div><h2>Estimated delivery</h2><p class="nt-shared-delivery__value"></p><p class="nt-shared-delivery__note"></p></div>';
  var value=card.querySelector('.nt-shared-delivery__value'),note=card.querySelector('.nt-shared-delivery__note');
  function text(el,copy){if(el.textContent!==copy)el.textContent=copy;}
  function sync(){
   var desktop=window.matchMedia('(min-width:1024px)').matches;
   var parent=desktop?root.querySelector('.nt-pc-info-scroll'):root.querySelector('.nt-pdp__details');
   if(!parent)return;
   if(card.parentNode!==parent)parent.appendChild(card);
   var type=root.dataset.fulfillment;
   var source=type==='us'?root.querySelector('[data-eta-result]'):root.querySelector('.nt-pc-delivery-unified h2, .nt-pdp__delivery #nt-delivery-title');
   var estimate=source?source.textContent.trim():'';
   // The live destination estimator can be empty before checkout has a usable address.
   // US-stock products still have a confirmed 3–5 business day service promise in
   // the native delivery block, so use that text instead of showing an error-like fallback.
   if(type==='us'&&!estimate){
    source=root.querySelector('.nt-pdp__delivery #nt-delivery-title');
    estimate=source?source.textContent.trim():'';
   }
   estimate=estimate.replace(/^Estimated delivery:\s*/i,'').replace(/^Delivery takes\s*/i,'');
   // Convert confirmed fulfillment durations to concrete estimated date ranges.
   var arrival=root.querySelector('[data-nt-presale-eta]');
   var raw=arrival?arrival.getAttribute('data-nt-presale-eta'):'';
   var match=(raw||'').match(/(\d{4})-(\d{2})-(\d{2})/);
   var base=new Date();base.setHours(12,0,0,0);
   var first,last;
   function plusDays(date,n,business){var result=new Date(date);while(n>0){result.setDate(result.getDate()+1);if(!business||(result.getDay()!==0&&result.getDay()!==6))n--;}return result;}
   if(type==='us'){
    var usDuration=estimate.match(/(\d+)\s*[\u2013-]\s*(\d+)\s*business days/i);
    if(usDuration){first=plusDays(base,Number(usDuration[1]),true);last=plusDays(base,Number(usDuration[2]),true);}
   }else if(type==='preorder'&&match){
     base=new Date(Number(match[1]),Number(match[2])-1,Number(match[3]),12);
     if(base>=new Date(new Date().setHours(0,0,0,0))){
      var duration=estimate.match(/(\d+)\s*[\u2013-]\s*(\d+)\s*business days/i);
      first=plusDays(base,duration?Number(duration[1]):3,true);last=plusDays(base,duration?Number(duration[2]):5,true);
     }else estimate='Delivery date pending warehouse arrival';
   }else if(type==='china'){
     first=plusDays(base,35,false);last=plusDays(base,42,false);
   }
   if(first&&last){var format=new Intl.DateTimeFormat('en-US',{month:'short',day:'numeric'});estimate=format.format(first)+' – '+format.format(last);}
   text(value,estimate||'See delivery details at checkout');
   var presale=root.querySelector('[data-nt-presale-date]');
   var detail=type==='preorder'?'Ships within 1 business day of US arrival · Delivery: 3–5 business days':type==='china'?'Made to order · Production + delivery: about 5–6 weeks':'Ships within 1 business day · Delivery: 3–5 business days';
   text(note,detail);
   var title=root.querySelector('.nt-pdp__title-row');
   if(type==='china'&&title&&!title.querySelector('.nt-made-order-label')){
    var badge=document.createElement('span');badge.className='nt-made-order-label';badge.textContent='Made to order';title.insertBefore(badge,title.firstChild);
   }
  }
  var queued=false;function schedule(){if(queued)return;queued=true;requestAnimationFrame(function(){queued=false;sync();});}
  var observer=new MutationObserver(schedule);observer.observe(root,{childList:true,subtree:true,characterData:true});
  root.addEventListener('nt:product:unload',function(){observer.disconnect();window.removeEventListener('resize',schedule);},{once:true});
  window.addEventListener('resize',schedule);sync();
 });}
 document.addEventListener('nt:product:mount',init);
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
